import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'
import { ActiveAnnouncementCampaign,AnnouncementCampaign } from 'types/campaigns'
import { CTAType } from 'types/message'

const useActiveAnnouncementCampaign = (): ActiveAnnouncementCampaign => {
  const { attributes = {}, id }: AnnouncementCampaign = useSelector(
    state => pathOr({}, ['campaigns', 'activeCampaign'], state)
  )

  return {
    id,
    playbookId: pathOr(null, ['playbookId'], attributes),
    ctaType: pathOr<CTAType>(null, ['cta', 'CtaType'], attributes),
    ctaCopy: pathOr('', ['cta', 'copy'], attributes),
    ctaUrl: pathOr('', ['cta', 'UrlLink'], attributes),
    body: attributes.message || '',
    title: attributes.title || '',
    thanksTitle: attributes.thankYouHeadline || '',
    thanksMessage: attributes.thankYouMessage || '',
    senderId: attributes.senderId,
    type: attributes.campaignDisplayType
  }
}

export default useActiveAnnouncementCampaign
